import { analytics } from './firebase';
import { logEvent } from 'firebase/analytics';

// Custom event names
export const AnalyticsEvents = {
  PAGE_VIEW: 'page_view',
  SIGN_IN: 'sign_in',
  SIGN_UP: 'sign_up',
  BRAND_CREATED: 'brand_created',
  BRAND_SHARED: 'brand_shared',
  BRAND_DOWNLOADED: 'brand_downloaded',
  ERROR_OCCURRED: 'error_occurred'
};

// Track page views
export const trackPageView = (pageName) => {
  if (analytics) {
    logEvent(analytics, AnalyticsEvents.PAGE_VIEW, {
      page_name: pageName,
      page_location: window.location.href,
      page_title: document.title
    });
  }
};

// Track user sign in
export const trackSignIn = (method) => {
  if (analytics) {
    logEvent(analytics, AnalyticsEvents.SIGN_IN, {
      method: method // 'google' or 'email'
    });
  }
};

// Track user sign up
export const trackSignUp = (method) => {
  if (analytics) {
    logEvent(analytics, AnalyticsEvents.SIGN_UP, {
      method: method // 'google' or 'email'
    });
  }
};

// Track brand creation
export const trackBrandCreated = (brandId) => {
  if (analytics) {
    logEvent(analytics, AnalyticsEvents.BRAND_CREATED, {
      brand_id: brandId
    });
  }
};

// Track brand sharing
export const trackBrandShared = (brandId) => {
  if (analytics) {
    logEvent(analytics, AnalyticsEvents.BRAND_SHARED, {
      brand_id: brandId
    });
  }
};

// Track brand download
export const trackBrandDownloaded = (brandId) => {
  if (analytics) {
    logEvent(analytics, AnalyticsEvents.BRAND_DOWNLOADED, {
      brand_id: brandId
    });
  }
};

// Track errors
export const trackError = (errorCode, errorMessage) => {
  if (analytics) {
    logEvent(analytics, AnalyticsEvents.ERROR_OCCURRED, {
      error_code: errorCode,
      error_message: errorMessage
    });
  }
}; 